import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, BookOpen, FileText } from 'lucide-react';
import { blogPosts } from '../data/blogPosts';
import { poetryPieces } from '../data/poetry';
import FloatingIcons from './FloatingIcons';

function Content() {
  // Get recent blog posts (latest 3)
  const recentBlogPosts = blogPosts.slice(0, 3);
  
  // Get recent poetry (latest 3)
  const recentPoetry = poetryPieces.slice(0, 3);

  return (
    <section className="content-section gray-wave" id="content">
      <FloatingIcons />
      <div className="container">
        <h3 className="section-title">Content & Writing</h3>
        <p className="section-subtitle" style={{ textAlign: 'center', marginBottom: '48px', color: 'var(--text-secondary)' }}>
          Technical articles and creative poetry
        </p>

        <div className="content-grid">
          {/* Blog Posts Section */}
          <div className="content-category">
            <div className="content-category-header">
              <FileText size={28} style={{ color: 'var(--primary-blue)' }} />
              <h4 className="content-category-title">Blog Posts</h4>
            </div>
            <div className="content-items">
              {recentBlogPosts.map((post, index) => {
                const formattedDate = new Date(post.date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric'
                });

                return (
                  <motion.div
                    key={post.id}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-50px" }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                  >
                    <Link to={`/blog/${post.id}`} className="content-item">
                      {post.logo && (
                        <div className="content-item-logo">
                          <img src={post.logo} alt={post.title} />
                        </div>
                      )}
                      <div className="content-item-text">
                        <h5 className="content-item-title">{post.title}</h5>
                        <span className="content-item-date">{formattedDate}</span>
                      </div>
                      <ArrowRight size={20} className="content-item-arrow" />
                    </Link>
                  </motion.div>
                );
              })}
            </div>
            <Link to="/blog" className="content-view-all">
              View All Blog Posts <ArrowRight size={16} />
            </Link>
          </div>

          {/* Poetry Section */}
          <div className="content-category">
            <div className="content-category-header">
              <BookOpen size={28} style={{ color: 'var(--primary-blue)' }} />
              <h4 className="content-category-title">कलम की जुबां</h4>
            </div>
            <div className="content-items">
              {recentPoetry.map((poem, index) => {
                const formattedDate = poem.date === 'TBD' ? 'Date TBD' : new Date(poem.date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric'
                });

                return (
                  <motion.div
                    key={poem.id}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-50px" }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                  >
                    <Link to={`/poetry/${poem.id}`} className="content-item">
                      {poem.logo && (
                        <div className="content-item-logo">
                          <img src={poem.logo} alt={poem.title} />
                        </div>
                      )}
                      <div className="content-item-text">
                        <h5 className="content-item-title">{poem.title}</h5>
                        <span className="content-item-date">{formattedDate}</span>
                      </div>
                      <ArrowRight size={20} className="content-item-arrow" />
                    </Link>
                  </motion.div>
                );
              })}
            </div>
            <Link to="/poetry" className="content-view-all">
              View All Poetry <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Content;

